import { UserRole } from '../types/User';

export const initializeTestAccounts = () => {
  const users = localStorage.getItem('users');
  
  // Clear and reinitialize if no users or if users are malformed
  if (!users || users === '[]') {
    const defaultUsers = [
      {
        id: '1',
        userid: 'admin',
        email: 'admin@example.com',
        password: 'admin123',
        name: '시스템 관리자',
        role: UserRole.SYSTEM_ADMIN
      },
      {
        id: '2',
        userid: 'manager',
        email: 'manager@example.com',
        password: 'manager123',
        name: '일반 관리자',
        role: UserRole.GENERAL_ADMIN
      },
      {
        id: '3',
        userid: 'user',
        email: 'user@example.com',
        password: 'user123',
        name: '일반 사용자',
        role: UserRole.GENERAL_USER
      }
    ];
    
    localStorage.setItem('users', JSON.stringify(defaultUsers));
    console.log('Test accounts initialized:', defaultUsers);
    return defaultUsers;
  }
  
  return JSON.parse(users);
};